import { render, staticRenderFns } from "./ProFooter.vue?vue&type=template&id=06b4745c&"
import script from "./ProFooter.vue?vue&type=script&lang=js&"
export * from "./ProFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports